module.exports = __webpack_public_path__ + "img/login-copaatahualpa.8cfc0edf.svg";